const isCom = location.host.includes("360.com");
const IS_ONLINE = ["online", "master", "devonline"].includes(import.meta.env.MODE)

const DSHosts = [
  "deepseek.chat.360.cn",
  "deepseek.n.cn",

  // 自测
  "local.chat.360.cn:3002",
];

export const isDS = DSHosts.includes(location.host);

const Conf = {
  appName: import.meta.env.VITE_APP_TITLE,
  shortAppName: import.meta.env.VITE_APP_TITLE,
  cloudKey: import.meta.env.VITE_CLOUD_KEY,
  appIcon: import.meta.env.VITE_APP_LOGO,
  appIconDark: import.meta.env.VITE_APP_LOGO_DARK,
  wxShareIcon: 'https://p0.qhimg.com/t11098f6bcdbd15d0e918e65ba4.png',
  bannerIcon: "https://p0.ssl.qhimg.com/t015141e94015b9bd6e.png",
  agentIocn: "https://p0.ssl.qhimg.com/d/inn/368d2a75b170/200.png",
  loginDomain : isCom ? "i.chat.360.com" : "i.360.cn",
  logoutDomain : isCom ? "login.360.com" : "login.360.cn",
  // app 信息
  companyInfo: {
    name: '小马开疆（北京）科技有限公司',
    shortname: '小马开疆',
    email: 'kefu@360.cn',
    zipcode: '100015',
    address: '中国北京市朝阳区酒仙桥路6号院电子城国际电子总部，360隐私保护部',
    mobile: "400-660-8360",
    icpcode: '20006251号-21', // 津ICP备20006251号-2
    recordcode: '12011602300304', // 津公网安备 xxxxxxxx 号
  },
  defaultUserAvatar : "https://p0.ssl.qhimg.com/t0105653c58c783f8fd.png", // 默认用户头像
  // 指定模型
  roleIds : {
    assistant : "bdb3818942e1a5a1dc49db512013c09a", // 助手
    zhinao : "d852fe1cc642306c72a984c772240a22",    // 智脑
    deepseek : IS_ONLINE ? "a0c817f8d3f097b5263048b29bfb5737" : "7798404f6187547a0d90ec0d828a9581", // DeepSeek
    knowledge : IS_ONLINE ? "65842a9222a173816a64b2d64b259b35" : "320462e5e4c82541e2cfd66a2f845939", // 知识库小助手
    dynamicPage: IS_ONLINE ? "5c6765360022ee42469b174ce1c763ed" : "5c6765360022ee42469b174ce1c763ed", // 动态网页
    dynamicPage2: IS_ONLINE ? "54743d49745c19ebf1df1809a6678ee3" : "54743d49745c19ebf1df1809a6678ee3",  // 动态网页2
  },
  // 指定智能体
  agentIds : {
    super : "9113bbe12b834c298ab65f7e54edbfd0", // 深入研究智能体
  },
};
window.loginDomain = Conf.loginDomain;  // 用于登出
window.logoutDomain = Conf.logoutDomain;
export default Conf;